var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-flex text-white px-1.5 text-xs rounded font-medium text-center items-center",class:_setup.classes},[(typeof _vm.status === 'number')?[_vm._v(" "+_vm._s(_vm.$t(`Enums.ServiceOrderStatus.${_vm.status}`))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('Enums.ServiceOrderStatus.New'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }